import { SearchInput } from 'framework/form';
import useOpportunityLookupService from '../opportunityLookupService';

const mapResponse = (opportunity: any) => ({
  id: opportunity.id,
  text: buildOpportunityAutoSuggestLabel(opportunity),
});

const buildOpportunityAutoSuggestLabel = (opportunity: any) =>
  !!opportunity && `${opportunity.name} (id: ${opportunity.id})`;

interface OpportunityInputProps {
  mapResults?: (opportunity: any) => void;
  props?: any;
}

const OpportunityInput = ({ mapResults = mapResponse, ...props }: OpportunityInputProps) => {
  const { search } = useOpportunityLookupService() as any;

  return (
    <SearchInput
      // @ts-ignore
      buildAutoSuggestLabel={buildOpportunityAutoSuggestLabel}
      searchRequest={search}
      noResultMessage="No Opportunities are found."
      mapResults={mapResults}
      {...props}
    />
  );
};

export default OpportunityInput;
